/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import LandingPageLayout from '../components/layouts/LandingPageLayout';
import TwoColumns from '../components/layouts/TwoColumns';
import {ColumnContainer, PersonSection} from '../components/layouts/TwoColumns';
import AmandaFox from '../assets/images/amandafox.png';
import Ellen from '../assets/images/ellenAccelerator.png';
import Eirik from '../assets/images/eirik.png';
import Eskild from '../assets/images/eskild.png';
import AcceleratorHeader from '../components/layouts/AcceleratorHeader';
import {CenteredContainer} from '../components/styled/CenteredContainer';
import {Cuributton} from '../components/_atoms/Cuributton';
import AcceleratorVideoCarousel from '../components/_molecules/AcceleratorVideoCarousel';
import CuriousCuriLogoForButton from '../assets/icons/CuriosCuriLogoForButton';
import {IconWrapper} from '../components/_atoms/IconWrapper';
import Image from 'next/image';
export const meta = {
  author: 'Jens Seip'
};
const MDXLayout = ({children}) => _jsx(LandingPageLayout, {
  customHeader: _jsx(AcceleratorHeader, {
    page: 'district'
  }),
  disableHeadline: true,
  mdx: true,
  meta: meta,
  children: children
});
function MDXContent(props = {}) {
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, {})
  })) : _createMdxContent();
  function _createMdxContent() {
    const _components = Object.assign({
      h2: "h2",
      p: "p",
      blockquote: "blockquote",
      ul: "ul",
      li: "li",
      a: "a",
      span: "span"
    }, props.components);
    return _jsxs(_Fragment, {
      children: [_jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsx(_components.h2, {
        children: "The AI Accelerator program"
      }), "\n", _jsx(_components.p, {
        children: "Artificial intelligence is transforming society and education, and the Curipod AI accelerator program is your opportunity to take the lead! The Curipod AI accelerator program - batch 2, is designed to help a few selected districts accelerate their competence within AI and become a leader within the space, providing the best education supported by artificial intelligence.\nThe program will be run by the Curipod team. They have built the leading educational AI tool used all over the world and guarantee real change!"
      }), "\n", _jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsx(_components.h2, {
        children: "What participating school leaders think about the Curipod AI Accelerator program."
      }), "\n", _jsxs(_components.blockquote, {
        children: ["\n", _jsx(_components.p, {
          children: "“It speaks to the quality of the program that multiple teachers were able to introduce Curipod in their classroom the day after the first session”"
        }), "\n"]
      }), "\n", _jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsx(AcceleratorVideoCarousel, {}), "\n", _jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsxs(_components.blockquote, {
        children: ["\n", _jsx(_components.p, {
          children: "“I loved their pedagogical approach of thinking about instruction first and technology second”"
        }), "\n"]
      }), "\n", _jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsx(_components.h2, {
        children: "The AI Accelerator program"
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "A few selected districts with leadership motivated to take a leading role in influencing how AI will transform education."
        }), "\n"]
      }), "\n", _jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsx(_components.h2, {
        children: "What does the accelerator program include?"
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "Professional development for teachers covering introduction to AI, the risks and limitations, and practical advice for using AI to save time and improve learning outcomes"
        }), "\n", _jsx(_components.li, {
          children: "Professional development for the leadership team, giving you the tools and knowledge to lead in the AI era"
        }), "\n", _jsx(_components.li, {
          children: "Discounted district license for Curipod"
        }), "\n", _jsx(_components.li, {
          children: "Network with like-minded innovative educational leaders from around the world."
        }), "\n"]
      }), "\n", _jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsx(_components.h2, {
        children: "What does the program cost?"
      }), "\n", _jsxs(_components.p, {
        children: ["It is a requirement to purchase a district license for Curipod (with a discount). Other than this, the rest of the program is entirely free of charge for the selected district.\nYou can find our list prices here: ", _jsx(_components.a, {
          href: "https://curipod.notion.site/Curipod-District-Prices-efe3a69dd6c848bb9a136160db77e6f7?pvs=4",
          children: "LINK"
        }), "\nUpon admission to the program you will receive a discounted quote for your district."]
      }), "\n", _jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsx(_components.h2, {
        children: "The application process"
      }), "\n", _jsx(_components.p, {
        children: "To apply, fill out the form provided below. After this, we will come back to you within a couple of days to let you know if your district is accepted into the program. Just so you know - we have very limited spots, so if your district is not accepted it does not mean that you can’t apply again at a later time."
      }), "\n", _jsx(CenteredContainer, {
        children: _jsx("a", {
          href: "https://forms.gle/HstTa92XDnBXCfom6",
          style: {
            textDecoration: 'none'
          },
          target: "__blank",
          rel: "noopener noreferrer",
          children: _jsxs(Cuributton, {
            role: "button",
            children: [_jsx(IconWrapper, {
              height: "60px",
              width: "60px",
              style: {
                position: 'absolute',
                top: -10,
                left: -10
              },
              children: _jsx(CuriousCuriLogoForButton, {})
            }), _jsx("span", {
              style: {
                whiteSpace: 'nowrap'
              },
              children: "Apply now!"
            })]
          })
        })
      }), "\n", _jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsx(_components.h2, {
        children: "Want to learn more?"
      }), "\n", _jsxs(_components.p, {
        children: ["Click here for Google Slides with more info about the program and pricing: ", _jsx(_components.a, {
          href: "https://docs.google.com/presentation/d/1KyUtpTRy9MJ3c5bv9JQeCcqgvbh-MWlP6nG52ew2gbE/edit#slide=id.g27f3ba6995d_0_1",
          children: "AI Accelerator Presentation"
        })]
      }), "\n", _jsxs(_components.p, {
        children: ["Download and share the one-pager about the AI Accelerator program ", _jsx(_components.a, {
          href: "https://docs.google.com/document/d/1mOVvyXwgZjmnw82ksiLP3o3JiQdDLjJp1xQBkgtTuXU/edit#heading=h.1xaigknttgao",
          children: "here"
        })]
      }), "\n", _jsxs(_components.p, {
        children: ["You can also schedule a meeting with us ", _jsx(_components.a, {
          href: "https://calendly.com/ellen-curipod/curipod-ai-accelerator-program-inquiry?month=2023-09",
          children: "here"
        }), " or reach out to ellen@curipod.com, at any time to learn more about the program.\nPlease note that we have a rolling admission and starting date, and we will review applicants continuously."]
      }), "\n", _jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsxs(TwoColumns, {
        children: [_jsx(PersonSection, {
          title: "Program Lead",
          name: "Ellen Barkost",
          role: "Product Manager in Curipod",
          content: _jsx(_components.span, {
            children: "Ellen Barkost is the Product Manager & the AI Accelerator lead at Curipod. She is dedicated to transforming education through AI. She has been leading the cutting-edge technology innovation in Curipod’s AI program and has extensive experience building several of Curipod’s key features, including many of the AI generators. She is also a world-class speaker and workshop facilitator."
          }),
          imageSrc: Ellen
        }), _jsx(PersonSection, {
          title: "Educational Strategies",
          name: "Eirik Hernes Berre",
          role: "COO & Co-Founder of Curipod",
          content: _jsx(_components.span, {
            children: "Eirik is a seasoned educator with expertise in working with schools and districts in Norway a leading country in transforming education and Africa. With the rise of artificial intelligence in education, Eirik understands the challenges teachers and administrators face and helps them navigate the opportunities and overcome the risks. As the COO and Co-Founder of Curipod, Eirik is part of a team dedicated to transforming education through AI."
          }),
          imageSrc: Eirik
        }), _jsx(PersonSection, {
          title: "AI Expert",
          name: "Eskild Ruud Mageli ",
          role: "Lead AI Engineer - Curipod",
          imageSrc: Eskild,
          content: _jsx(_components.span, {
            children: "Eskild is the Lead AI Engineer at Curipod, responsible for building the Curipod AI system. With his previous experience as a teacher, Eskild is a natural at explaining the intricacies of generative AI to educators in a clear and engaging way. His expertise is invaluable to the Curipod team and the schools and districts participating in the AI accelerator program."
          })
        }), _jsx(PersonSection, {
          title: "AI in Education expert",
          name: "Amanda Fox",
          role: "Community Manager in Curipod",
          content: _jsx(_components.span, {
            children: "Amanda Fox, the community manager at Curipod and author of the best-selling book \"The AI Classroom,\" resides in Louisville, Kentucky. She has also written other notable books such as \"Markertown,\" \"Teachingland: A Teacher's Survival Guide to the Classroom Apocalypse,\" and \"Zom-Be A Design Thinker.\" Amanda is a recipient of the 2016 ISTE Emerging Leader Award and has significantly contributed to the STEM Excellence award. She is recognized as a PBS Digital innovator for her initiatives in enhancing student learning with technology. Additionally, Amanda has served as the President of the Young Educator Network for ISTE and received the President's Volunteer Award."
          }),
          imageSrc: AmandaFox
        })]
      }), "\n", _jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsx("br", {})]
    });
  }
}
export default MDXContent;
